import {
  BooleanInput,
  Create,
  DateInput,
  NumberInput,
  ReferenceInput,
  SelectInput,
  SimpleForm,
  TextInput,
} from "@/components/admin"
import { RaRecord, required, useGetIdentity } from "ra-core"
import { ReactElement } from "react"
const formClass =
  "grid lg:grid-cols-4 md:grid-cols-4 sm:grid-cols-2 xs:grid-cols-6 gap-3 gap-y-6 sm:px-0 lg:mx-22 md:mx-6 sm:mx-4 my-8"

const ProjectCreate = (): ReactElement => {
  const { data: identity } = useGetIdentity()

  return (
    <Create
      title="Créer un nouveau projet"
      redirect="edit"
      transform={(data: RaRecord) => ({
        ...data,
        client_id: identity?.id,
      })}
    >
      <SimpleForm>
        <div className={formClass}>
          <TextInput label="Titre" source="title" validate={required()} />
          <NumberInput
            label="Surface (m²)"
            source="surface"
            validate={required()}
          />

          <NumberInput
            label="Nombre d'étages"
            source="floors"
            validate={required()}
          />
          <NumberInput
            label="Nombre de chambres"
            source="bedrooms"
            validate={required()}
          />

          <NumberInput label="Budget min." source="budget.min" />

          <NumberInput label="Budget max." source="budget.max" />

          <DateInput label="Date de début" source="dates.start" />
          <DateInput label="Date d'achèvement" source="dates.end" />
          <ReferenceInput reference="project_types" source="type">
            <SelectInput />
          </ReferenceInput>

          <ReferenceInput
            reference="project_styles"
            source="architectural_style"
          >
            <SelectInput />
          </ReferenceInput>
          <ReferenceInput reference="cities" source="city">
            <SelectInput />
          </ReferenceInput>

          <TextInput label="Région" source="region" />

          <BooleanInput source="has_garden" label="Je veux un jardin" />
          <BooleanInput source="has_pool" label="Je veux une piscine" />
          <BooleanInput source="has_terrace" label="Je veux une terrasse" />
          <BooleanInput source="has_basement" label="Je veux un sous-sol" />
        </div>
      </SimpleForm>
    </Create>
  )
}

export default ProjectCreate
